import { render } from "./PowerupsList.vue?vue&type=template&id=30771ed6&scoped=true"
import script from "./PowerupsList.vue?vue&type=script&lang=js"
export * from "./PowerupsList.vue?vue&type=script&lang=js"

import "./PowerupsList.vue?vue&type=style&index=0&id=30771ed6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30771ed6"]])

export default __exports__